import React, { useState, useEffect } from 'react';
import Header from '../components/header';
import Footer from '../components/footer';
import FloatingChatButton from '../components/FloatingChatButton';

// Thailand Hospitals Data (using representative names for Thailand hospitals)
const topThailandHospitals = [
  {
    name: "Bumrungrad International Hospital",
    image: "https://dummyimage.com/300x200/1976f2/ffffff?text=Bumrungrad+Hospital",
    link: "/hospitals/bumrungrad-international-hospital/"
  },
  {
    name: "Bangkok Hospital",
    image: "https://dummyimage.com/300x200/1976f2/ffffff?text=Bangkok+Hospital",
    link: "/hospitals/bangkok-hospital/"
  },
  {
    name: "Samitivej Hospital",
    image: "https://dummyimage.com/300x200/1976f2/ffffff?text=Samitivej+Hospital",
    link: "/hospitals/samitivej-hospital/"
  },
  {
    name: "Chulalongkorn Hospital",
    image: "https://dummyimage.com/300x200/1976f2/ffffff?text=Chulalongkorn+Hospital",
    link: "/hospitals/chulalongkorn-hospital/"
  },
  {
    name: "Ramathibodi Hospital",
    image: "https://dummyimage.com/300x200/1976f2/ffffff?text=Ramathibodi+Hospital",
    link: "/hospitals/ramathibodi-hospital/"
  },
  {
    name: "Siriraj Hospital",
    image: "https://dummyimage.com/300x200/1976f2/ffffff?text=Siriraj+Hospital",
    link: "/hospitals/siriraj-hospital/"
  }
];

// Thailand Doctors Data (using representative doctor data for Thailand)
const topThailandDoctors = [
  {
    name: "Dr. Somchai Tanapat",
    specialty: "Cardiology",
    qualification: "MD Cardiology",
    experience: "25",
    image: "/images/image copy 34.png",
    link: "/doctors/dr-somchai-tanapat/"
  },
  {
    name: "Dr. Siriporn Wongprasert",
    specialty: "Oncology",
    qualification: "MD Oncology",
    experience: "22",
    image: "/images/image copy 35.png",
    link: "/doctors/dr-siriporn-wongprasert/"
  },
  {
    name: "Dr. Kritsada Phuakpong",
    specialty: "Orthopedics",
    qualification: "MD Orthopedics",
    experience: "30",
    image: "/images/image copy 36.png",
    link: "/doctors/dr-kritsada-phuakpong/"
  },
  {
    name: "Dr. Nattaporn Chaiyasit",
    specialty: "Cosmetic Surgery",
    qualification: "MD Plastic Surgery",
    experience: "18",
    image: "/images/image copy 37.png",
    link: "/doctors/dr-nattaporn-chaiyasit/"
  },
  {
    name: "Dr. Thanakorn Suwannatrai",
    specialty: "Neurosurgery",
    qualification: "MD Neurosurgery",
    experience: "28",
    image: "/images/image copy 38.png",
    link: "/doctors/dr-thanakorn-suwannatrai/"
  },
  {
    name: "Dr. Panida Ratchanon",
    specialty: "Dermatology",
    qualification: "MD Dermatology",
    experience: "20",
    image: "/images/image copy 39.png",
    link: "/doctors/dr-panida-ratchanon/"
  }
];

const StarDoctorsThailand = () => {
  const [currentHospitalIndex, setCurrentHospitalIndex] = useState(0);
  const [currentDoctorIndex, setCurrentDoctorIndex] = useState(0);
  const [isAutoSliding, setIsAutoSliding] = useState(true);

  // Auto-slide functionality
  useEffect(() => {
    if (!isAutoSliding) return;

    const interval = setInterval(() => {
      setCurrentHospitalIndex(prev => (prev + 1) % Math.ceil(topThailandHospitals.length / 4));
      setCurrentDoctorIndex(prev => (prev + 1) % Math.ceil(topThailandDoctors.length / 4));
    }, 4000);

    return () => clearInterval(interval);
  }, [isAutoSliding]);

  // Slider controls for hospitals
  const nextHospitalSlide = () => {
    setCurrentHospitalIndex(prev => (prev + 1) % Math.ceil(topThailandHospitals.length / 4));
    setIsAutoSliding(false);
  };

  const prevHospitalSlide = () => {
    setCurrentHospitalIndex(prev => prev === 0 ? Math.ceil(topThailandHospitals.length / 4) - 1 : prev - 1);
    setIsAutoSliding(false);
  };

  // Slider controls for doctors
  const nextDoctorSlide = () => {
    setCurrentDoctorIndex(prev => (prev + 1) % Math.ceil(topThailandDoctors.length / 4));
    setIsAutoSliding(false);
  };

  const prevDoctorSlide = () => {
    setCurrentDoctorIndex(prev => prev === 0 ? Math.ceil(topThailandDoctors.length / 4) - 1 : prev - 1);
    setIsAutoSliding(false);
  };

  const getHospitalsToShow = (hospitals, currentIndex) => {
    const itemsPerSlide = 4;
    const start = currentIndex * itemsPerSlide;
    return hospitals.slice(start, start + itemsPerSlide);
  };

  const getDoctorsToShow = (doctors, currentIndex) => {
    const itemsPerSlide = 4;
    const start = currentIndex * itemsPerSlide;
    return doctors.slice(start, start + itemsPerSlide);
  };

  return (
    <div>
      <Header />

      {/* Thailand Banner Section */}
      <section className="py-0">
        <img 
          src="https://medicallinkers.org/img/countries/thailand/thailand-banner.webp" 
          alt="Thailand Banner" 
          className="w-full h-auto"
        />
      </section>

      {/* About Thailand Culture Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://medicallinkers.org/img/countries/thailand/abouts-thailand.webp" 
                alt="Thailand Culture" 
                className="w-full h-auto rounded-lg"
              />
            </div>
            
            <div>
              <h2 className="text-3xl font-bold mb-6">About Thailand's Culture</h2>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Thailand is a land where spirituality meets serenity, and tradition blends effortlessly with modern life. Warm smiles, deep-rooted Buddhist values, and a harmonious way of living make every traveler feel embraced and at peace. Whether you're visiting a vibrant temple, enjoying a street food feast, or receiving care at a world-class hospital, Thailand surrounds your medical journey with grace, mindfulness, and gentle care.
              </p>
              
              <ul className="space-y-3 mb-8">
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-[#1976f2] mr-3" fill="currentColor" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                  Welcoming People
                </li>
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-[#1976f2] mr-3" fill="currentColor" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                  Vibrant Culture
                </li>
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-[#1976f2] mr-3" fill="currentColor" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                  Top Medical Destination
                </li>
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-[#1976f2] mr-3" fill="currentColor" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                  Last Mile Assistance
                </li>
              </ul>

              <div className="flex flex-wrap gap-4">
                <a 
                  href="https://wa.me/9599222655" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-blue-100 text-[#1976f2] px-6 py-3 rounded-lg font-semibold hover:bg-blue-200 transition"
                >
                  Learn More
                </a>
                <button className="bg-[#1976f2] text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-600 transition">
                  Get a call back
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Thailand Cities Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold">
              <span className="text-[#1976f2]">Thailand</span> Cities
            </h3>
            <p className="mt-3 text-gray-600">These Thailand cities are known for multiple leading treatments and medical services.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="bg-white rounded-lg p-6 text-center shadow-md hover:shadow-lg transition">
              <svg className="w-8 h-8 text-[#1976f2] mx-auto mb-3" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
              </svg>
              <h5 className="text-xl font-semibold">Bangkok</h5>
            </div>
            
            <div className="bg-white rounded-lg p-6 text-center shadow-md hover:shadow-lg transition">
              <svg className="w-8 h-8 text-[#1976f2] mx-auto mb-3" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
              </svg>
              <h5 className="text-xl font-semibold">Chiang Mai</h5>
            </div>
            
            <div className="bg-white rounded-lg p-6 text-center shadow-md hover:shadow-lg transition">
              <svg className="w-8 h-8 text-[#1976f2] mx-auto mb-3" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
              </svg>
              <h5 className="text-xl font-semibold">Phuket</h5>
            </div>
          </div>
        </div>
      </section>

      {/* Leading Treatments Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold mb-6">Thailand is a leading country in the following treatments</h2>
              
              <ul className="space-y-4">
                <li className="flex items-center justify-between">
                  <div className="flex items-center">
                    <svg className="w-4 h-4 text-[#1976f2] mr-3" fill="currentColor" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                    Cardiology
                  </div>
                  <a href="/focussed-specialities/" className="text-[#1976f2] hover:underline">Learn More</a>
                </li>
                <li className="flex items-center justify-between">
                  <div className="flex items-center">
                    <svg className="w-4 h-4 text-[#1976f2] mr-3" fill="currentColor" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                    Oncology
                  </div>
                  <a href="/focussed-specialities/" className="text-[#1976f2] hover:underline">Learn More</a>
                </li>
                <li className="flex items-center justify-between">
                  <div className="flex items-center">
                    <svg className="w-4 h-4 text-[#1976f2] mr-3" fill="currentColor" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                    Cosmetic Surgery
                  </div>
                  <a href="/focussed-specialities/" className="text-[#1976f2] hover:underline">Learn More</a>
                </li>
                <li className="flex items-center justify-between">
                  <div className="flex items-center">
                    <svg className="w-4 h-4 text-[#1976f2] mr-3" fill="currentColor" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                    Dental Care
                  </div>
                  <a href="/focussed-specialities/" className="text-[#1976f2] hover:underline">Learn More</a>
                </li>
                <li className="flex items-center justify-between">
                  <div className="flex items-center">
                    <svg className="w-4 h-4 text-[#1976f2] mr-3" fill="currentColor" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                    Orthopedics
                  </div>
                  <a href="/focussed-specialities/" className="text-[#1976f2] hover:underline">Learn More</a>
                </li>
                <li className="flex items-center justify-between">
                  <div className="flex items-center">
                    <svg className="w-4 h-4 text-[#1976f2] mr-3" fill="currentColor" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                    Wellness & Spa
                  </div>
                  <a href="/focussed-specialities/" className="text-[#1976f2] hover:underline">Learn More</a>
                </li>
              </ul>
            </div>
            
            <div>
              <img 
                src="https://medicallinkers.org/img/countries/thailand/about-thailand.webp" 
                alt="Thailand Treatment" 
                className="w-full h-auto rounded-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto">
            <div className="bg-white rounded-lg shadow-lg p-8">
              <div className="text-center mb-8">
                <h2 className="text-2xl font-semibold mb-2">Searching for a treatment in Thailand?</h2>
                <p className="text-gray-600">Fill the form to get a call back from our support team</p>
              </div>
              
              <form className="space-y-4">
                <div>
                  <input
                    type="text"
                    placeholder="Your Name"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1976f2]"
                  />
                </div>
                
                <div>
                  <input
                    type="tel"
                    placeholder="Mobile Number"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1976f2]"
                  />
                </div>
                
                <div>
                  <input
                    type="email"
                    placeholder="Your Email"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1976f2]"
                  />
                </div>
                
                <div>
                  <input
                    type="text"
                    placeholder="Your Preferred Language"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1976f2]"
                  />
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <input
                      type="text"
                      placeholder="Country"
                      className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1976f2]"
                    />
                  </div>
                  <div>
                    <input
                      type="text"
                      placeholder="City"
                      className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1976f2]"
                    />
                  </div>
                </div>
                
                <div>
                  <textarea
                    placeholder="Describe Your Questions"
                    rows="4"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1976f2]"
                  ></textarea>
                </div>
                
                <div>
                  <button
                    type="submit"
                    className="w-full bg-[#1976f2] text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-600 transition"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Top Hospitals Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold">
              <span className="text-[#1976f2]">Top Hospitals</span> in Thailand
            </h3>
          </div>

          <div className="relative">
            {/* Navigation Buttons */}
            <button 
              onClick={prevHospitalSlide}
              className="absolute left-0 top-1/2 transform -translate-y-1/2 z-10 bg-white shadow-lg rounded-full p-2 hover:bg-gray-50 transition"
            >
              <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            
            <button 
              onClick={nextHospitalSlide}
              className="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 bg-white shadow-lg rounded-full p-2 hover:bg-gray-50 transition"
            >
              <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>

            {/* Hospitals Slider */}
            <div className="overflow-hidden">
              <div 
                className="flex transition-transform duration-300 ease-in-out"
                style={{ transform: `translateX(-${currentHospitalIndex * 100}%)` }}
              >
                {Array.from({ length: Math.ceil(topThailandHospitals.length / 4) }).map((_, slideIndex) => (
                  <div key={slideIndex} className="w-full flex-shrink-0">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                      {getHospitalsToShow(topThailandHospitals, slideIndex).map((hospital, index) => (
                        <div key={index} className="bg-white rounded-lg shadow-md hover:shadow-lg transition p-4 text-center">
                          <img
                            src={hospital.image}
                            alt={hospital.name}
                            className="w-full h-40 object-cover rounded-lg mx-auto mb-4"
                          />
                          <h4 className="text-lg font-semibold">
                            <a href={hospital.link} className="hover:text-[#1976f2] transition">
                              {hospital.name}
                            </a>
                          </h4>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Top Doctors Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold">
              <span className="text-[#1976f2]">Top Doctors</span> in Thailand
            </h3>
          </div>

          <div className="relative">
            {/* Navigation Buttons */}
            <button 
              onClick={prevDoctorSlide}
              className="absolute left-0 top-1/2 transform -translate-y-1/2 z-10 bg-white shadow-lg rounded-full p-2 hover:bg-gray-50 transition"
            >
              <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            
            <button 
              onClick={nextDoctorSlide}
              className="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 bg-white shadow-lg rounded-full p-2 hover:bg-gray-50 transition"
            >
              <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>

            {/* Doctors Slider */}
            <div className="overflow-hidden">
              <div 
                className="flex transition-transform duration-300 ease-in-out"
                style={{ transform: `translateX(-${currentDoctorIndex * 100}%)` }}
              >
                {Array.from({ length: Math.ceil(topThailandDoctors.length / 4) }).map((_, slideIndex) => (
                  <div key={slideIndex} className="w-full flex-shrink-0">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                      {getDoctorsToShow(topThailandDoctors, slideIndex).map((doctor, index) => (
                        <div key={index} className="bg-white rounded-lg shadow-md hover:shadow-lg transition p-6 text-center">
                          <img
                            src={doctor.image}
                            alt={doctor.name}
                            className="w-full h-40 object-cover rounded-lg mx-auto mb-4"
                          />
                          <h4 className="text-lg font-semibold mb-2">
                            <a href={doctor.link} className="hover:text-[#1976f2] transition">
                              {doctor.name}
                            </a>
                          </h4>
                          <h6 className="text-gray-600 mb-1 text-sm">
                            {doctor.specialty} | {doctor.qualification}
                          </h6>
                          <h5 className="text-gray-500 text-sm">{doctor.experience} Years Of Experience</h5>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Tourism & Leisure Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <p className="text-gray-600 font-semibold">Tourism & Leisure</p>
            <h3 className="text-3xl font-bold">
              <span className="text-[#1976f2]">Things to do</span> in Thailand
            </h3>
            <p className="mt-3 text-gray-600 max-w-2xl mx-auto">
              Thailand is a country of colours and festivals, it has all the seasons and geographies to make it a fulfilling tourism spot.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition p-6">
              <h5 className="text-xl font-semibold mb-4 text-[#1976f2]">Festivals</h5>
              <p className="text-gray-600 mb-4">
                Celebrate life through mesmerizing events like Songkran (Thai New Year) and Loy Krathong, where floating lanterns and water blessings fill the air with joy and spiritual renewal.
              </p>
              <a href="#" className="text-[#1976f2] hover:underline inline-flex items-center">
                Learn More 
                <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </a>
            </div>

            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition p-6">
              <h5 className="text-xl font-semibold mb-4 text-[#1976f2]">Natural Rejoice</h5>
              <p className="text-gray-600 mb-4">
                Whether it's the turquoise waters of Krabi, the misty hills of Chiang Mai, or tranquil island retreats, Thailand's nature is deeply restorative.
              </p>
              <a href="#" className="text-[#1976f2] hover:underline inline-flex items-center">
                Learn More 
                <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </a>
            </div>

            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition p-6">
              <h5 className="text-xl font-semibold mb-4 text-[#1976f2]">Traditional Therapy</h5>
              <p className="text-gray-600 mb-4">
                Rooted in centuries of healing wisdom, Thai wellness includes herbal medicine, Thai massage, and meditation practices that balance body and mind.
              </p>
              <a href="#" className="text-[#1976f2] hover:underline inline-flex items-center">
                Learn More 
                <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </a>
            </div>

            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition p-6">
              <h5 className="text-xl font-semibold mb-4 text-[#1976f2]">Food</h5>
              <p className="text-gray-600 mb-4">
                Savor the vibrant flavors of Thai cuisine—from comforting bowls of tom yum soup to fragrant green curry and sticky rice with mango, every bite fuels recovery and joy.
              </p>
              <a href="#" className="text-[#1976f2] hover:underline inline-flex items-center">
                Learn More 
                <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </a>
            </div>

            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition p-6">
              <h5 className="text-xl font-semibold mb-4 text-[#1976f2]">Shopping</h5>
              <p className="text-gray-600 mb-4">
                Explore bustling night markets for silk scarves, handcrafted decor, and herbal wellness products—perfect souvenirs for soul and senses.
              </p>
              <a href="#" className="text-[#1976f2] hover:underline inline-flex items-center">
                Learn More 
                <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </a>
            </div>

            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition p-6">
              <h5 className="text-xl font-semibold mb-4 text-[#1976f2]">Entertainment</h5>
              <p className="text-gray-600 mb-4">
                Enjoy everything from traditional Muay Thai performances to temple fairs and soothing classical Thai music, all woven into the rhythm of daily life.
              </p>
              <a href="#" className="text-[#1976f2] hover:underline inline-flex items-center">
                Learn More 
                <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="py-16 bg-[#1976f2]">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
            <div className="lg:col-span-2">
              <h4 className="text-3xl font-bold text-white">
                Plan a relaxing treatment &<br/>
                stay tour in Thailand today
              </h4>
            </div>
            <div className="text-center lg:text-right">
              <p className="text-white mb-4">We charge<br/>0% planning fee</p>
              <a 
                href="https://wa.me/9599222655" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-lg font-semibold transition inline-flex items-center"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                Chat Now
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <FloatingChatButton />
    </div>
  );
};

export default StarDoctorsThailand;
